const FEATURE_FLAG_COMPONENTS = {
	healthCard: {
		segmentation: true,
	},
};

export default FEATURE_FLAG_COMPONENTS;
